import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Szoa110aRequest, Szoa110aResponse, SZOA110AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSzoa110aService {
  /** 付帯商品一覧取得結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Szoa110aResponse>();

  /**
  * 付帯商品一覧取得結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSzoa110aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZOA110AService} SZOA110AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSzoa110aService
   */
  constructor(
    private sZOA110AService: SZOA110AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 付帯商品一覧取得API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Szoa110aResponse>}
   * @memberof UsedSgkb122dSzoa110aService
   */
  searchContractor(value: Szoa110aRequest): Observable<Szoa110aResponse> {
    // 検索条件を保存
    return this.sZOA110AService.c11RSZOA110APost(<Szoa110aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラー内容リストに「DB該当データなし(SZZZ0026) 」が含まれる場合、正常扱いとするため、除外
          const filteredErrors = response.body.responseCommon.errors.filter(
            (error) => error.errorCode !== SgkbConstains.ERROR_CODE.SZZZ0026
          );
          // 除外処理後のエラー内容リストが空の場合
          if (filteredErrors.length === 0) {
              // 処理結果コード、処理結果詳細コードを「正常」に書き換え
              response.body.responseCommon.resultCode = SgkbConstains.RESULT_CD.NORMAL;
              response.body.responseCommon.resultDetailCode = SgkbConstains.RESULT_DETAIL_CODE.SZZZ_N000;
          }
          response.body.responseCommon.errors = filteredErrors;
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SZOA110A);
          return throwError(err.message);
        })
      );
  }
}
